import { AxiosPromise } from 'axios';
import { apiV1, armorAPI } from '~/services/api';

// TODO: Rename this to getManifestsToCreate or something similar getManifestableGroups?
// TODO: type params
// https://shippo.atlassian.net/browse/ENG-17605
function getManifestGroups(dateRangeStart, dateRangeEnd, carrierObjectId) {
  return armorAPI.request({
    method: 'GET',
    url: `/manifests/groups/`,
    params: {
      date_range_start: dateRangeStart,
      date_range_end: dateRangeEnd,
      carrier_account_object_id: carrierObjectId,
      is_test: false,
    },
  });
}

// TODO: rename createManifest and type params
function generateManifest(params) {
  return apiV1.request({
    url: 'v1/manifests',
    method: 'POST',
    data: {
      ...params,
      address_from: {
        ...params.address_from,
        country: params.address_from?.country?.iso2,
      },
    },
  });
}

function downloadManifestDocumentsZip(manifestID: number): AxiosPromise<ArrayBuffer> {
  return armorAPI.request<ArrayBuffer>({
    url: `/manifests/documents/${manifestID}`,
    method: 'GET',
    responseType: 'arraybuffer',
  });
}

function getManifestsByObjectIds(manifestObjectIds: string[]) {
  return armorAPI.request({
    url: '/manifests',
    method: 'GET',
    params: {
      manifests: manifestObjectIds,
    },
  });
}

/**
 *
 * @param dateRangeStart - RFC3339 formatted datetime string
 * @param dateRangeEnd - RFC3339 formatted datetime string
 */
function getManifestsByDateRange(dateRangeStart: string, dateRangeEnd: string) {
  return armorAPI.request({
    url: '/manifests',
    method: 'GET',
    params: {
      date_range_start: dateRangeStart,
      date_range_end: dateRangeEnd,
    },
  });
}

export {
  getManifestGroups,
  generateManifest,
  downloadManifestDocumentsZip,
  getManifestsByObjectIds,
  getManifestsByDateRange,
};
